import React from 'react';
import {
  LANDING_HOW_IT_WORKS_ID,
  LANDING_HOW_IT_WORKS_STEPS,
  LANDING_SECTION_HOW_IT_WORKS,
} from '../../landing/landingCopy';

const LscLandingHowItWorks: React.FC = () => {
  return (
    <section
      id={LANDING_HOW_IT_WORKS_ID}
      className="space-y-8 scroll-mt-24"
      data-testid="lsc-landing-how-it-works"
    >
      <div className="text-center space-y-3">
        <h2 className="text-2xl md:text-3xl font-bold text-white">{LANDING_SECTION_HOW_IT_WORKS}</h2>
        <p className="text-secondary-400 max-w-2xl mx-auto">
          A simple path from league streams to a polished media hub.
        </p>
      </div>
      <ol className="relative grid gap-5 md:grid-cols-2 xl:grid-cols-4">
        <div
          className="pointer-events-none absolute left-0 right-0 top-8 hidden h-px bg-gradient-to-r from-transparent via-primary-600/30 to-transparent xl:block"
          aria-hidden
        />
        {LANDING_HOW_IT_WORKS_STEPS.map(({ step, title, description }) => (
          <li
            key={step}
            className="relative rounded-xl border border-secondary-700/80 bg-gradient-to-b from-secondary-800/60 to-secondary-900/80 p-5 space-y-3 shadow-md"
            data-testid="lsc-landing-how-step"
          >
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary-900/60 text-sm font-bold text-primary-100 ring-2 ring-primary-700/40">
              {step}
            </span>
            <h3 className="text-base font-semibold text-white">{title}</h3>
            <p className="text-sm text-secondary-400 leading-relaxed">{description}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default LscLandingHowItWorks;
